export default __webpack_public_path__ + "static/media/AssertivenessInfluencing.77f05f8f.png";